import React from 'react';
import { Flex, Switch, Text } from '@chakra-ui/react';

export interface AleaToggleInlineProps {
  isChecked: boolean;
  onToggle: (e: React.ChangeEvent<HTMLInputElement>) => void;
  leftLabel?: string; // e.g., Nein
  rightLabel?: string; // e.g., Ja
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
}

const AleaToggleInline: React.FC<AleaToggleInlineProps> = ({
  isChecked,
  onToggle,
  leftLabel = 'No',
  rightLabel = 'Yes',
  size = 'lg',
  disabled = false,
}) => {
  const inactiveColor = disabled ? 'gray.400' : '#2B4956';
  const activeWeight = 500; // on state
  const inactiveWeight = 300; // off state

  return (
    <Flex align="center" gap="15px">
      <Text color={inactiveColor} fontWeight={isChecked ? inactiveWeight : activeWeight} fontSize="15px">
        {leftLabel}
      </Text>
      <Switch
        isChecked={isChecked}
        onChange={onToggle}
        colorScheme="green"
        size={size}
        isDisabled={disabled}
        sx={{
          'span.chakra-switch__track:not([data-checked])': {
            backgroundColor: '#C6C6C6',
          },
          'span.chakra-switch__track[data-disabled]': {
            opacity: 0.4,
            cursor: 'not-allowed',
          },
        }}
      />
      <Text color={inactiveColor} fontWeight={isChecked ? activeWeight : inactiveWeight} fontSize="15px">
        {rightLabel}
      </Text>
    </Flex>
  );
};

export default AleaToggleInline;


